import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ImageIntroPage} from "./ImageIntroPage";
import {GameClientConfiguration} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";
import {TombstoneNoMercy} from "../TombstoneNoMercy";

export class TBNoMercyIntroConfig implements GameIntroViewConfig {
    colors:GameIntroColors = {
        slideShowColors : {
            backgroundColor : 0x000000, //Default 0x000000
            backgroundAlpha : 0.4, //Default 0.4
            bulletColor : 0xffffff, //Default 0xffffff

        },
        stampColor : 0xFFFFFF
    };

    stampConfig:StampConfig = {
        xNudge : true,
        volatility : Volatility.EXTREME,
        xBet : true
    };

    background: PIXI.Container;
    borderBottom: PIXI.Container;
    borderTop: PIXI.Container;
    logo: PIXI.Container;
    pages: SlideShowPage[];

    private _logoSprite:PIXI.Sprite;

    constructor() {

    }

    init(): Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/introBg.jpg");
        imgLoader.add("introDiv", "resources/images/bar.png");
        imgLoader.add("logo", "resources/images/introLogo.png");

        // Outlaw Wilds
        imgLoader.add("page1", "resources/images/Features_1.png");

        // 108 win ways
        imgLoader.add("page2", "resources/images/Features_2.png");

        // Justice, Gunslinger, Bounty.
        imgLoader.add("page3", "resources/images/Features_3.png");

        // Boosted Bet
        imgLoader.add("page4", "resources/images/BOOSTED_BET.png");

        // Boosted bet wild
        imgLoader.add("page5", "resources/images/BOOSTED_BET_WILD.png");


        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
        //return Promise.resolve(undefined);
    }

    public gameClientConfigurationApplied(rules: GameClientConfiguration) {
        if(TombstoneNoMercy.api.gameClientConfiguration.boostedBetAllowed) {
            this.addBoostPage();
        }
    }

    private addBoostPage() {

        const pages: ImageIntroPage [] = [
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("page4"),
                    scale : 0.75,
                    position : new PIXI.Point(-130, 0)
                }
            ], TombstoneNoMercy.api.translations.translate("xBET: SCATTER/OUTLAW WILD")),
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("page5"),
                    scale : 0.75,
                    position : new PIXI.Point(-130, 0)
                }
            ], TombstoneNoMercy.api.translations.translate("xBET: OUTLAW WILD"))
        ];
        //this.pages.splice(0, 0, page);
        pages.forEach((page) => {
            this.pages.push(page);
        });
    }


    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        this._logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        this._logoSprite.anchor.set(0.5, 1);
        this._logoSprite.y = 50; // total position y=135.
        this._logoSprite.scale.set(0.3);
        this.logo.addChild(this._logoSprite);

        const xBet:PIXI.Text = new PIXI.Text("xBet: SCATTER/OUTLAW WILD", {
            fontSize: 80,
            fontColor: 0xFFFFFF
        });


        this.pages = [
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("page1"),
                    scale : 0.6,
                    position : new PIXI.Point(-100, 0)
                },
                {
                    texture : ImgLoader.getImgTexture("page2"),
                    scale : 1,
                    position : new PIXI.Point(120, 20)
                }
            ]),
            new ImageIntroPage([
                {
                    texture : ImgLoader.getImgTexture("page3"),
                    scale : 0.75,
                    position : new PIXI.Point(0, 0)
                }
            ]),
        ];
    }
}